module.exports = __webpack_public_path__ + "img/projects_post_service.3347fc1c.svg";